// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"211":"00f584a2","355":"a48519ab","453":"670e15c7","947":"57857b60"}[chunkId] + ".chunk.js";
};